import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-xs-12 col-sm-10 col-md-8 col-lg-7 news__view-card" }
const _hoisted_2 = { class: "news__view-card-title s-pb-md" }
const _hoisted_3 = { class: "col-xs-12 news__view-card-date s-pb-md row items-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "news__view-card-source s-pb-sm"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_page_header = _resolveComponent("s-page-header")!
  const _component_news_skeleton_item = _resolveComponent("news-skeleton-item")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_s_card = _resolveComponent("s-card")!
  const _component_s_page = _resolveComponent("s-page")!

  return (_openBlock(), _createBlock(_component_s_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_s_page_header, {
        "back-label": "Вернуться к списку новостей",
        back: { name: 'news' },
        "is-loading": _ctx.isLoading
      }, null, 8, ["is-loading"]),
      _createVNode(_component_s_card, { class: "row justify-center" }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_news_skeleton_item, { key: 0 }))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_s_icon, {
                name: "app:date",
                size: "middle",
                class: "s-mr-sm not-hovered"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.getNewsDate), 1)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_q_img, {
                class: "news__view-card-image",
                src: _ctx.getImage(_ctx.news.imageId, _ctx.news.id),
                alt: "Изображение новости",
                onError: _ctx.imageNotLoading
              }, null, 8, ["src", "onError"])
            ]),
            _createElementVNode("div", {
              class: "news__view-card-description s-pb-lg",
              innerHTML: _ctx.getNewsDescription
            }, null, 8, _hoisted_4),
            (_ctx.getNewsSource)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-grey" }, "Источник: ", -1)),
                  (_ctx.getNewsSourceLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "s-link",
                        href: _ctx.getNewsSourceLink,
                        target: "_blank",
                        rel: "nofollow noopener"
                      }, _toDisplayString(_ctx.getNewsSource), 9, _hoisted_6))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.getNewsSource), 1))
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !_ctx.isLoading]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}